import AuthService from '../AuthService';
import routes from '../../routes';
import HttpClient from '../REST/HttpClient';
import { Subscription } from 'rxjs';

class RouteChangeHandler {
    constructor() {
        this.menuItems = AuthService.getMenuItems();
        this.subscriptions = null;
    }
    
    handleRouteChange(props) {
        this.subscriptions = new Subscription();
        const path = props.location.pathname;

        let pathName = null;

        for (let item of this.menuItems) {
            if (item.url === path) pathName = item.name;
        }
        if (!pathName) pathName = routes[path];
        if (!pathName) pathName = path;
        if (pathName === 'FINRA Visualisation' || pathName === 'Regulatory Tagging Tool' || pathName.includes('/finra-visualisation/') || pathName.includes('/finra-rules/')) return
        this.sendRequest(pathName);
    }

    sendRequest(pathName) {
        this.subscriptions.add(
            HttpClient.post('/usage/', { feature_code: pathName }).subscribe(() => {
                this.unsubscribe();
            })
        );
    }

    unsubscribe() {
        this.subscriptions.unsubscribe();
    }
}

export default new RouteChangeHandler();


// WEBPACK FOOTER //
// ./src/services/RouteServices/RouteChangeHandler.js